import { render, staticRenderFns } from "./EmailTemplate2.vue?vue&type=template&id=bc9e453a&"
import script from "./EmailTemplate2.vue?vue&type=script&lang=js&"
export * from "./EmailTemplate2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports